<script>
	import { onMount } from 'svelte';
	import ComponentPageHead from '$lib/components/ComponentPageHead.svelte';
	export let data;
	const { page } = data;
	/**
	 * @type {typeof import('svelte').SvelteComponent}
	 */
	let Component;

	onMount(async () => {
		Component = await page.init();
	});
</script>

{#if Component}
	<ComponentPageHead content={page.metadata} />
	<svelte:component
		this={Component}
		pageData={data}
	/>
{/if}
